angular.module('pitch.app').controller('EMIPolandCtrl',
    function($scope, $timeout, SiteContext, Site, SelectOfficeModal) {

        "use strict";
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/EMIPolandCtrl.js